/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Invite_CopiedInputs */

const cs_settings_users_invite_copied = /** @type {(inputs: Settings_Users_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz na pozvánku zkopírován`)
};

const en_settings_users_invite_copied = /** @type {(inputs: Settings_Users_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link copied`)
};

/**
* | output |
* | --- |
* | "Invite link copied" |
*
* @param {Settings_Users_Invite_CopiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_invite_copied = /** @type {((inputs?: Settings_Users_Invite_CopiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Invite_CopiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_invite_copied(inputs)
	return cs_settings_users_invite_copied(inputs)
});